/* External Imports */
import { Box, Image } from '@chakra-ui/react';
import Slider from 'react-slick';

/**
 * 
 * @param {Object} images 
 * @returns 
 */
const MobileCardGallery = ({ images }) => {
  // console.log('MobileCardGallery', images);
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 5000,
    autoplaySpeed: 2000,
    cssEase: 'linear',
  };

  return (
    <Box textAlign="center">
      <Slider {...settings}>
        {images.map((imageCard, index) => {
          return (
            <Box key={index} px={2}>
              <Image
                src={imageCard?.url}
                alt={imageCard?.alt}
                width="100%"
                height="24.5rem"
                objectFit="cover"
                my="3"
              />
            </Box>
          );
        })}
      </Slider>
    </Box>
  );
};

export default MobileCardGallery;
